const getRisksTourStepId = ({ STEPS, isPreAvaliation, fromCreate, step }) =>
  fromCreate
    ? isPreAvaliation
      ? STEPS.PRE_AVALIATION.CREATION.RISKS[step]
      : STEPS.CREATION.RISKS[step]
    : isPreAvaliation
    ? STEPS.PRE_AVALIATION.EDIT.RISKS[step]
    : STEPS.EDIT.RISKS[step]

export default getRisksTourStepId
